import {
    Directive,
    Input,
    HostListener,
    OnDestroy,
    Output,
    EventEmitter
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ShowDlgDecorationService } from './show-dlg-decoration.service';
import { DlgDecorationComponent } from './dlg-decoration';

import { UserRoomsService } from './user-rooms.service';

@Directive({
    selector: '[appShowDlgDecoration]'
})
export class ShowDlgDecorationDirective implements OnDestroy {
    @Input() decoration: any;
    @Input() decorations: any[];
    @Input() themes: any[];
    @Input() active: any;

    @Output() convert: EventEmitter<any> = new EventEmitter();
    @Output() activate: EventEmitter<any> = new EventEmitter();
    @Output() deactivate: EventEmitter<any> = new EventEmitter();

    private _dialogRef: MatDialogRef<DlgDecorationComponent>;

    @HostListener('click')
    onClick(): void {
        this.showDialog();
    }

    constructor(
        private _showDlgDecorationService: ShowDlgDecorationService,
        private _userRoomsService: UserRoomsService
    ) {
    }

    ngOnDestroy() {
        if (this._dialogRef) {
            this._dialogRef.close();
        }
    }

    showDialog(): void {
        this._dialogRef = this._showDlgDecorationService.showDialog({
            decoration: this.decoration,
            decorations: this.decorations,
            themes: this.themes,
            active: this.active,
            rooms$: this._userRoomsService.rooms$,
            convert: ($event) => this.convert.emit($event),
            activate: ($event) => this.activate.emit($event),
            deactivate: ($event) => this.deactivate.emit($event)
        });

        this._dialogRef.afterClosed().subscribe(() => {
            this._dialogRef = null;
        });
    }
}
